import React from "react";
import t from '../../../../helpers/t';
import Biscuit from "../../../../../utils/Biscuit";

const NewResourceGroupButtton = (props) => {

  const onButtonClicked = (e) => {
            props.onClicked(e);
        };

  return (
    <>
      <a
          href={props.url}
          id="inb-c-left-bar-add-usergroup"
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('add_${a}',{a:t('usergroup',null, 'capital')})}
          </span>
      </a>
    </>
  );
};
export default NewResourceGroupButtton;